module.exports = __webpack_public_path__ + "static/media/54.841593c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/54.jpg
// module id = 422
// module chunks = 0